import ModaleChooseDestinataireController from './modale.choose.destinataire.controller';
import ModaleChooseDestinataireHtml from './modale.choose.destinataire.tpl.html';
export default {
	bindings: {
		resolve: '<',
		close: '&',
		dismiss: '&'
	},
	template: ModaleChooseDestinataireHtml,
	controller: ModaleChooseDestinataireController
};
